module.exports = __webpack_public_path__ + "img/taste-character.f8f4c585.png";